module.exports = __webpack_public_path__ + "7a116e6530145b21653c0b995fa701f8.png";